import type { FC } from "react";

import { CoreSegmentCell } from "pro-features/components/core cells/src/CoreSegmentCell/CoreSegmentCell";
import { externalLinkFilter } from "app/filters/ngFilters";
import { allTrackers } from "app/services/track/track";

import type { IDomain } from "../../MarketBuilder.types";

import { DomainItem, DomainItemContainer, DomainRowContainer, StyledIconButton } from "./SelectedDomainsList.styles";

interface ISelectedDomainItem {
    entity: IDomain;
    onDeleteSegment: (domain: IDomain) => void;
    isNewSegment: boolean;
}

export const SelectedSegmentItem: FC<ISelectedDomainItem> = ({ entity, onDeleteSegment, isNewSegment }) => {
    const { domain = "", favicon = "", segmentName = "", id, lastUpdated } = entity;
    return (
        <DomainRowContainer isNewDomain={isNewSegment}>
            <DomainItemContainer>
                <DomainItem>
                    <CoreSegmentCell
                        withWebsiteSign={true}
                        segmentName={segmentName}
                        isOrgSegment={false}
                        segmentId={id}
                        lastModified={lastUpdated}
                        icon={favicon}
                        domain={domain}
                        externalLink={externalLinkFilter(domain)}
                        subtitleFilters={[
                            {
                                filter: "text",
                                value: segmentName,
                            },
                        ]}
                        trackExternalLink={() =>
                            allTrackers.trackEvent("external link", "click", `marketBuilder/your list`)
                        }
                    />
                </DomainItem>
                <StyledIconButton
                    type="flat"
                    iconName="delete"
                    onClick={onDeleteSegment}
                />
            </DomainItemContainer>
        </DomainRowContainer>
    );
};
